<template>
  <div class="pre-next-paging">
    <div class="pre-next-content">
      <div
        :class="['left', previousdetail?.title ? '' : 'no-next']"
        @click="toPrePage(previousdetail)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.4741 8.86203C9.39133 8.94791 9.27784 8.99742 9.15859 8.99967C9.03933 9.00192 8.92406 8.95673 8.8381 8.87403L6.1381 6.32403C6.09455 6.28205 6.05991 6.23172 6.03625 6.17605C6.01259 6.12039 6.00039 6.06052 6.00039 6.00003C6.00039 5.93954 6.01259 5.87967 6.03625 5.824C6.05991 5.76833 6.09455 5.71801 6.1381 5.67603L8.8381 3.12603C8.88022 3.08298 8.93055 3.04882 8.9861 3.02558C9.04166 3.00234 9.10132 2.99049 9.16155 2.99073C9.22177 2.99096 9.28133 3.00329 9.33671 3.02697C9.39208 3.05065 9.44214 3.0852 9.48391 3.12858C9.52568 3.17196 9.55833 3.22329 9.5799 3.27952C9.60147 3.33574 9.61154 3.39573 9.60951 3.45592C9.60748 3.51611 9.59338 3.57528 9.56806 3.62992C9.54274 3.68456 9.50671 3.73357 9.4621 3.77403L7.0993 6.00003L9.4621 8.22603C9.54798 8.3088 9.59749 8.42229 9.59974 8.54155C9.60199 8.6608 9.5568 8.77607 9.4741 8.86203ZM5.8741 8.86203C5.79133 8.94791 5.67784 8.99742 5.55859 8.99967C5.43933 9.00192 5.32406 8.95673 5.2381 8.87403L2.5381 6.32403C2.49455 6.28205 2.45991 6.23172 2.43625 6.17605C2.41259 6.12039 2.40039 6.06052 2.40039 6.00003C2.40039 5.93954 2.41259 5.87967 2.43625 5.824C2.45991 5.76833 2.49455 5.71801 2.5381 5.67603L5.2381 3.12603C5.28022 3.08298 5.33055 3.04882 5.38611 3.02558C5.44166 3.00234 5.50132 2.99049 5.56155 2.99073C5.62177 2.99096 5.68133 3.00329 5.73671 3.02697C5.79208 3.05065 5.84214 3.0852 5.88391 3.12858C5.92568 3.17196 5.95833 3.22329 5.9799 3.27952C6.00147 3.33574 6.01154 3.39573 6.00951 3.45592C6.00748 3.51611 5.99338 3.57528 5.96806 3.62992C5.94274 3.68456 5.90671 3.73357 5.8621 3.77403L3.4993 6.00003L5.8621 8.22603C5.94798 8.3088 5.99749 8.42229 5.99974 8.54155C6.00199 8.6608 5.9568 8.77607 5.8741 8.86203Z"
            fill="#333333"
          />
        </svg>
        <span>上一篇：{{ previousdetail?.title || "暂无" }}</span>
      </div>
      <div
        :class="['right', nextdetail?.title ? '' : 'no-next']"
        @click="toNextPage(nextdetail)"
      >
        <span>下一篇：{{ nextdetail?.title || "暂无" }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.4741 8.86203C9.39133 8.94791 9.27784 8.99742 9.15859 8.99967C9.03933 9.00192 8.92406 8.95673 8.8381 8.87403L6.1381 6.32403C6.09455 6.28205 6.05991 6.23172 6.03625 6.17605C6.01259 6.12039 6.00039 6.06052 6.00039 6.00003C6.00039 5.93954 6.01259 5.87967 6.03625 5.824C6.05991 5.76833 6.09455 5.71801 6.1381 5.67603L8.8381 3.12603C8.88022 3.08298 8.93055 3.04882 8.9861 3.02558C9.04166 3.00234 9.10132 2.99049 9.16155 2.99073C9.22177 2.99096 9.28133 3.00329 9.33671 3.02697C9.39208 3.05065 9.44214 3.0852 9.48391 3.12858C9.52568 3.17196 9.55833 3.22329 9.5799 3.27952C9.60147 3.33574 9.61154 3.39573 9.60951 3.45592C9.60748 3.51611 9.59338 3.57528 9.56806 3.62992C9.54274 3.68456 9.50671 3.73357 9.4621 3.77403L7.0993 6.00003L9.4621 8.22603C9.54798 8.3088 9.59749 8.42229 9.59974 8.54155C9.60199 8.6608 9.5568 8.77607 9.4741 8.86203ZM5.8741 8.86203C5.79133 8.94791 5.67784 8.99742 5.55859 8.99967C5.43933 9.00192 5.32406 8.95673 5.2381 8.87403L2.5381 6.32403C2.49455 6.28205 2.45991 6.23172 2.43625 6.17605C2.41259 6.12039 2.40039 6.06052 2.40039 6.00003C2.40039 5.93954 2.41259 5.87967 2.43625 5.824C2.45991 5.76833 2.49455 5.71801 2.5381 5.67603L5.2381 3.12603C5.28022 3.08298 5.33055 3.04882 5.38611 3.02558C5.44166 3.00234 5.50132 2.99049 5.56155 2.99073C5.62177 2.99096 5.68133 3.00329 5.73671 3.02697C5.79208 3.05065 5.84214 3.0852 5.88391 3.12858C5.92568 3.17196 5.95833 3.22329 5.9799 3.27952C6.00147 3.33574 6.01154 3.39573 6.00951 3.45592C6.00748 3.51611 5.99338 3.57528 5.96806 3.62992C5.94274 3.68456 5.90671 3.73357 5.8621 3.77403L3.4993 6.00003L5.8621 8.22603C5.94798 8.3088 5.99749 8.42229 5.99974 8.54155C6.00199 8.6608 5.9568 8.77607 5.8741 8.86203Z"
            fill="#333333"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  previousdetail: {
    type: Object,
    default: () => {},
  },
  nextdetail: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(["toPrePage", "toNextPage"]);

const toPrePage = () => {
  emit("toPrePage");
};
const toNextPage = () => {
  emit("toNextPage");
};
</script>

<style lang="scss" scoped>
.pre-next-paging {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 88px;

  .pre-next-content {
    width: calc(100% - 48px);
    height: 88px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    line-height: 24px;
    color: #333333;
    border-top: 0.5px solid #e9e9e9;
    cursor: pointer;
    .left {
      text-align: left;
      span {
        margin-left: 4px;
      }
    }
    .right {
      text-align: right;
      span {
        margin-right: 4px;
      }
      svg {
        transform: rotate(180deg);
      }
    }
    .no-next {
      cursor: default;
      color: #999999;
      svg {
        path {
          fill: #999999;
        }
      }
    }
  }
}
</style>
